import { Link } from 'react-router-dom';
import { memberBenefits } from '@/mocks/data';

export default function MembershipPreview() {
  const previewBenefits = memberBenefits.slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-8 h-px bg-accent-400/60"></span>
            <span className="text-accent-600 text-sm tracking-widest font-label uppercase">
              会员权益
            </span>
            <span className="w-8 h-px bg-accent-400/60"></span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            加入琉璃神社会员
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md mx-auto">
            解锁专属资源、创作工具与线下活动权益，成为琉璃神社大家庭的一员
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {previewBenefits.map((benefit) => (
            <div
              key={benefit.id}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 hover:border-primary-200 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${benefit.icon} text-lg`}></i>
              </div>
              <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium mb-2 inline-block">
                {benefit.level}
              </span>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-2">
                {benefit.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/membership"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap text-sm"
          >
            查看全部会员权益
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}